<template>
  <div class="rt-detail-bottom">
    <div class="left">
      <rt-row v-for="(row, index) in content" :key="index">
        <rt-col
          v-for="(col, index2) in row.attrs"
          :key="index2"
          :span="col.span"
          :align="col.align"
        >
          <rt-attr
            :label="col.label"
            :text="col.text"
            :light="col.light"
            type="primary"
          />
        </rt-col>
      </rt-row>
    </div>
    <div class="right">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'RtDetailBottom',
  props: {
    content: {
      type: Array
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtDetailBottom.vue?39efd549